import axios from "../../axios/index.js"


export default {
  Add(circulaireData) {
    let formData = new FormData();
    formData.append("file", circulaireData.file)
    formData.append("observation", circulaireData.observation)
    formData.append("fileName", circulaireData.fileName)
    formData.append("clientId", circulaireData.clientId)
    formData.append("clientName", circulaireData.clientName)
    return axios.post("commandesfiles", formData,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  getAll() {
    return axios.get("commandesfiles",
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },

  download(id) {
    return axios.get("commandesfiles/download/" + id,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  valider(id) {
    return axios.get("commandesfiles/" + id,
    { headers: { Authorization: 'Bearer ' + localStorage.getItem("accessToken") } })
  },
}
